import { useEffect } from "react";

export function useMount(callback: () => void | Promise<void>, unmountCallback?: () => void): void {
  useEffect(() => {
    const result = callback();
    if (result instanceof Promise) {
      result.catch(() => {});
    }

    return () => {
      if (unmountCallback) {
        unmountCallback();
      }
    };
  }, []);
}
